import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";
import { fetchWrapper } from "utils/apiFetch";

export default function IncompleteFormModal({ show, onClose, mode, userData, onSuccess }) {
  const [errors, setErrors] = useState({});
  const { userid } = useSession();
  

  const validateForm = () => {
    const requiredFields = ["incompleteId"];
    let newErrors = {};

    requiredFields.forEach((field) => {
      const value = document.querySelector(`[name="${field}"]`)?.value?.trim();
      if (!value) {
        newErrors[field] = `${field.replace("_", " ")} is required.`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCheckStatus = async () => {
    if (!validateForm()) {
        showMainToast("Please fill all required fields", "danger");
        return;
      }
  
      const formData = new FormData(document.getElementById("incomplete-check-form"));
      formData.append("userid", userid);
      formData.append("action", "Incorrect Application");
  
  
      try {
        const response = await fetchWrapper("https://api.mokshiq.in/nsdl_action", {
          method: "POST",
          body: formData,
        });
  
     
        if (response.status) {
          debugger;
          showMainToast(response.response || "PAN Application Submitted!", "success");
          const reqData = response.data; // your full 'req' value as JSON or string

          // Create a form element dynamically
          const form = document.createElement("form");
          form.method = "POST";
          form.action = "https://assisted-service.egov.proteantech.in/SpringBootFormHandling/newPanReq";
          form.target = "_blank"; // open in new tab
        
          // Create hidden input for 'req'
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "req";
          input.value = reqData; // make sure it's a string
          form.appendChild(input);
        
          // Append the form to body and submit
          document.body.appendChild(form);
          form.submit();
        
          // Optional: remove the form after submission
          document.body.removeChild(form);
          if (onSuccess) onSuccess();
          onClose();
        } else {
          showMainToast(response.data || "Submission failed", "danger");
        }
      } catch (err) {
        showMainToast("Something went wrong!", "danger");
      }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title="Check Application Status"
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: "Correct Form", className: "btn-primary", onClick: handleCheckStatus },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="incomplete-check-form">
             {/* Request ID */}
          <div className="col-md-6">
            <label className="form-label">Incomplete Application ID</label>
            <input
              className={`form-control ${errors.requestid ? "is-invalid" : ""}`}
              name="incompleteId"
              type="text"
              defaultValue={userData?.requestid || ""}
            />
            {errors.requestid && (
              <div className="text-danger mt-1">{errors.requestid}</div>
            )}
          </div>
          

         
        </form>
      </div>
    </BaseModal>
  );
}
